import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import { PhotoGalleryByDate } from "./photoGalleryByDate";

interface PhotoGalleryByDateModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  photos: PhotoGalleryByDate[];
  enableZoom?: boolean;
  selectedPhotoKey?: string;
  minZoomScale?: number;
  maxZoomScale?: number;
}

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    width: '100%',
    maxWidth: '100%',
    maxHeight: "100%",
    height: '100vh',
    margin: 0,
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(1),
  },
  content: {
    height: 'calc(90vh - 64px)',
    padding: "16px",
    overflow: 'hidden',
  },
}));


export const PhotoGalleryByDateModal: React.FC<PhotoGalleryByDateModalProps> = ({
  open,
  onClose,
  title = "Gallery",
  photos,
  enableZoom = false,
  selectedPhotoKey,
  minZoomScale,
  maxZoomScale
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      classes={{ paper: classes.dialogPaper }}
      fullWidth
    >
      <DialogTitle disableTypography className={classes.titleWrapper}>
        <h2>{title}</h2>
        <IconButton onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.content}>
        <PhotoGalleryByDate photos={photos} enableZoom={enableZoom} selectedPhotoKey={selectedPhotoKey} minZoomScale={minZoomScale} maxZoomScale={maxZoomScale} />
      </DialogContent>
    </Dialog>

  );
};
